function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isNil } from 'ramda';
import CustomerCareKeys from '../../../../locales/keys';
import { performCreditCheck } from '../../../../reducers/actions/credit.check.actions';
import { IsCreditCheckEnabledSelector, IsMatchSubscriberCreditCheckDetailsSelector, SubscriberCreditCheckDetailsSelector, SubscriberCreditCheckStatusSelector } from '../../../../reducers/selectors/credit.check.selectors';
import { CurrentCustomerSelector } from '../../../../reducers/selectors/customer.selectors';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
var StatusButtonController = /*#__PURE__*/function () {
  function StatusButtonController($ngRedux, uiNotificationService) {
    _classCallCheck(this, StatusButtonController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerCareKeys: CustomerCareKeys,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(StatusButtonController, [{
    key: "$onInit",
    value: function $onInit() {
      this.connectRedux();
      if (!this.state.subscriberCreditCheckDetails.isFetchingData && !this.state.isMatchSubscriberCreditCheckDetails) {
        this.performCreditCheck();
      }
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      this.connectRedux();
      if (changesObj.subscriberId && !isNil(changesObj.subscriberId.currentValue) && changesObj.subscriberId.currentValue !== changesObj.subscriberId.previousValue) {
        if (!this.state.subscriberCreditCheckDetails.isLoaded && !this.state.subscriberCreditCheckDetails.isFetchingData) {
          this.performCreditCheck();
        }
      }
      if (changesObj.subscriberCategory && !isNil(changesObj.subscriberCategory.currentValue) && changesObj.subscriberCategory.currentValue !== changesObj.subscriberCategory.previousValue) {
        if (!this.state.subscriberCreditCheckDetails.isFetchingData) {
          this.performCreditCheck();
        }
      }
      if (changesObj.subscriberType && changesObj.subscriberType.currentValue) {
        if (!this.state.subscriberCreditCheckDetails.isFetchingData) {
          this.performCreditCheck();
        }
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "buttonClicked",
    value: function buttonClicked() {
      if (this.onClick()) {
        this.onClick()();
      }
    }
  }, {
    key: "connectRedux",
    value: function connectRedux() {
      var _this = this;
      if (!this.disconnectRedux) {
        var controllerActions = {
          performCreditCheck: performCreditCheck
        };
        var mapStateToTarget = function mapStateToTarget(store) {
          return {
            currentCustomer: CurrentCustomerSelector(store),
            isCreditCheckEnabled: IsCreditCheckEnabledSelector(store),
            isMatchSubscriberCreditCheckDetails: IsMatchSubscriberCreditCheckDetailsSelector(store),
            subscriberCreditCheckDetails: SubscriberCreditCheckDetailsSelector(store) || {},
            subscriberCreditCheckStatus: SubscriberCreditCheckStatusSelector(store)
          };
        };
        this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
          _this.state = state;
          _this.actions = actions;
        });
      }
    }
  }, {
    key: "performCreditCheck",
    value: function performCreditCheck() {
      var _this2 = this;
      this.actions.performCreditCheck(this.subscriberCategory, this.subscriberId, convertStringToNumber(this.subscriberType)).catch(function (err) {
        _this2.uiNotificationService.transientError(err.translatedMessage);
      });
    }
  }]);
}();
export default {
  template: require('./status.button.html'),
  controller: StatusButtonController,
  bindings: {
    onClick: '&?',
    subscriberCategory: '<',
    // Subscriber Category or ID is required
    subscriberId: '<',
    subscriberType: '<'
  },
  controllerAs: 'StatusButton'
};